<template>
  <div id="error" :style="{'height': height - 60 + 'px'}">
  </div>
</template>

<script>
export default {
  name: 'error',
  data () {
    return {
      height: ''
    }
  },
  mounted () {
    let _this = this
    this.height = window.innerHeight || window.screen.availHeight || document.body.clientHeight
    window.onresize = function () {
      _this.height = window.innerHeight || window.screen.availHeight || document.body.clientHeight
    }
  }
}
</script>

<style scoped>
#error {
  width: 100%;
  height: 100%;
  background-image: url(../assets/img/404.gif);
  background-repeat: no-repeat;
  background-position: top;
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/404.vue